import {CodeAndExchange} from "app/instruments/types/CodeAndExchange";
import {ObjectUtil} from "../../js/util/ObjectUtil";
import {QuoteParameters, TmcQuoteParameters} from "./QuoteParameters";
import {Equality} from "../../types/GenericTypes";
import {PortfolioType} from "../../portfolio/models/Portfolio";

export type QuoteRequests = ReadonlyArray<QuoteRequest>;

export type QuoteRequest = QuoteParameters;

export interface TmcQuoteRequest extends QuoteRequest, TmcQuoteParameters {
    readonly legs: ReadonlyArray<TmcQuoteRequestLeg>;
}

export interface TmcQuoteRequestLeg extends CodeAndExchange {
    readonly ratio: number;
}

export function isTmcRequest(request: QuoteRequest): request is TmcQuoteRequest {
    return "legs" in request;
}

export function securityQuoteRequest(security: CodeAndExchange, portfolioType: PortfolioType): QuoteRequest {
    return {
        ...security,
        portfolioType
    };
}

export function copyRequest(request: QuoteRequest): QuoteRequest {
    if (isTmcRequest(request)) {
        const legs = request.legs.map((l) => ObjectUtil.pick(l, "code", "exchange", "ratio"));
        return {
            code: request.code,
            exchange: request.exchange,
            portfolioType: request.portfolioType,
            opposite: request.opposite,
            legs
        } as TmcQuoteRequest;
    } else {
        return ObjectUtil.pick(request, "code", "exchange", "portfolioType");
    }
}

export function quoteRequestMatcher(): Equality<QuoteRequest> {
    return (a, b) => (a.code === b.code) && (a.exchange === b.exchange) && (a.portfolioType === b.portfolioType);
}
